// Recovered compiled webpack factory 86871. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      ACTION_HMR_REFRESH: function () {
        return s;
      },
      ACTION_NAVIGATE: function () {
        return n;
      },
      ACTION_PREFETCH: function () {
        return i;
      },
      ACTION_REFRESH: function () {
        return r;
      },
      ACTION_RESTORE: function () {
        return a;
      },
      ACTION_SERVER_ACTION: function () {
        return l;
      },
      ACTION_SERVER_PATCH: function () {
        return o;
      },
      PrefetchCacheEntryStatus: function () {
        return c;
      },
      PrefetchKind: function () {
        return u;
      },
    }));
  let r = "refresh",
    n = "navigate",
    a = "restore",
    o = "server-patch",
    i = "prefetch",
    s = "hmr-refresh",
    l = "server-action";
  var u = (function (e) {
      return ((e.AUTO = "auto"), (e.FULL = "full"), (e.TEMPORARY = "temporary"), e);
    })({}),
    c = (function (e) {
      return (
        (e.fresh = "fresh"),
        (e.reusable = "reusable"),
        (e.expired = "expired"),
        (e.stale = "stale"),
        e
      );
    })({});
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
